function startOfDay(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

/** @returns {{ day: number, month: number } | null} month is 0-based */
export function parseMonthDay(value) {
  if (value == null || value === '') return null;

  const raw = String(value).trim();

  const dmy = raw.match(/^(\d{1,2})[-./](\d{1,2})[-./](\d{2,4})$/);
  if (dmy) {
    const day = Number(dmy[1]);
    const month = Number(dmy[2]) - 1;
    if (day >= 1 && day <= 31 && month >= 0 && month <= 11) {
      return { day, month };
    }
  }

  const parsed = new Date(raw.includes('T') ? raw : `${raw}T12:00:00`);
  if (!Number.isNaN(parsed.getTime())) {
    return { day: parsed.getDate(), month: parsed.getMonth() };
  }

  return null;
}

/** Next occurrence in the current calendar year (year from DB is ignored). */
export function deadlineInCurrentYear(value) {
  const parts = parseMonthDay(value);
  if (!parts) return null;

  const today = startOfDay(new Date());
  const target = new Date(today.getFullYear(), parts.month, parts.day);
  if (Number.isNaN(target.getTime())) return null;
  return startOfDay(target);
}

/** Days until deadline; negative = overdue (same year, month/day only). */
export function daysUntilAdmissionDeadline(value) {
  const target = deadlineInCurrentYear(value);
  if (!target) return null;
  const today = startOfDay(new Date());
  return Math.round((target - today) / (1000 * 60 * 60 * 24));
}

/** Display: «31 мая» without year. */
export function formatAdmissionDeadline(value) {
  const parts = parseMonthDay(value);
  if (!parts) return value ? String(value) : '—';

  const d = new Date(2000, parts.month, parts.day);
  if (Number.isNaN(d.getTime())) return String(value);

  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
}
